import { Stack, Typography } from "@mui/material"
import React from "react"
import {
  Button,
  StaticSnackbar
} from "../../../mp-shared-components/generic-shared-components/components"
import { FaIcon } from "../../icons"
import { useStyles } from "./styles"

export interface Props {
  id?: string
  text: string | React.ReactElement
  buttonName: string
  buttonLoading?: boolean
  buttonStartIcon?: string | React.ReactElement
  onButtonClick: () => void
  className?: string
}

const getButtonStartIconComponent = (
  buttonStartIcon: string | React.ReactElement
) => {
  if (!buttonStartIcon) {
    return null
  }

  if (typeof buttonStartIcon === "string") {
    return <FaIcon solid name={buttonStartIcon} />
  }

  return buttonStartIcon
}

const TopBanner: React.FC<Props> = ({
  id,
  text,
  buttonName,
  buttonLoading = false,
  buttonStartIcon,
  onButtonClick,
  className
}) => {
  const { classes, cx } = useStyles()

  return (
    <StaticSnackbar
      id={id}
      variant="dark"
      severity="persistent"
      className={cx(classes.topBanner, className)}
      message={
        <Stack
          width="100%"
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {typeof text === "string" ? (
            <Typography variant="subtitle1">{text}</Typography>
          ) : (
            text
          )}

          <Button
            size="xs"
            variant="contained"
            loading={buttonLoading}
            disabled={buttonLoading}
            className={classes.topBannerButton}
            startIcon={getButtonStartIconComponent(buttonStartIcon)}
            onClick={onButtonClick}
          >
            {buttonName}
          </Button>
        </Stack>
      }
    />
  )
}

export default TopBanner
